import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import axiosInstance from "../../../axiosInstance";
import { closeModal } from "../../../redux/actions/actions";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

const DiscountRequestModal = ({
  open,
  data,
  getQuoteDetails,
  onSuccess,
  getStudents,
}) => {
  const { t } = useTranslation();

  const [discountName, setDiscountName] = useState("");
  const [note, setNote] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    if (!discountName || !note || !amount) return alert("Fill the all fields!");

    const payload = {
      quote_option_id: data?.option?.option_id,
      quote_option_course_id: data?.course?.option_course_id,
      discount_name: discountName,
      note,
      amount: Number(amount),
      amount_type: "fixed",
    };

    try {
      setLoading(true);

      const accessToken = localStorage.getItem("accessToken");
      const token = localStorage.getItem("loginUser");
      let url = `${process.env.REACT_APP_BASE_URL}discount_request`;

      const response = await axiosInstance.post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        icon: "success",
        title: `${t("discountRequestCreatedSuccessfully")}!`,
        showConfirmButton: false,
        showCloseButton: true,
      });
      getStudents();
      setLoading(false);
      getQuoteDetails();
      if (onSuccess) onSuccess(); // başarılı işlem sonrası callback
      dispatch(closeModal()); // modal kapat
    } catch (err) {
      console.error("Error:", err);
      setLoading(false);
    }
  };

  return (
    <>
      <Box>
        <TextField
          fullWidth
          sx={{ textTransform: 'capitalize' }}
          label={t("discountName")}
          value={discountName}
          onChange={(e) => setDiscountName(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          sx={{ textTransform: 'capitalize' }}
          label={t("notes")}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          margin="normal"
          multiline
          rows={3}
        />
        <TextField
          fullWidth
          sx={{ textTransform: 'capitalize' }}
          label={t("discountAmount")}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          margin="normal"
          type="number"
        />
      </Box>
      <Box mt={2}>
        <Button
          fullWidth
          size="large"
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !discountName || !note || !amount}
        >
          {loading ? <CircularProgress size={22} /> : t("createDiscountRequest")}
        </Button>
      </Box>
    </>
  );
};

export default DiscountRequestModal;
